export default __webpack_public_path__ + "static/media/donutmaker1.abc80339.JPG";